module.exports = __webpack_public_path__ + "img/fb.f3cc062d.svg";